var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1769 5.51562H9.49405C9.34555 5.51562 9.20433 5.59219 9.11698 5.72344L6.82835 9.12969L5.79176 7.58594C5.70441 7.45625 5.56465 7.37813 5.41469 7.37813H4.73189C4.63726 7.37813 4.58193 7.49375 4.63726 7.57656L6.45127 10.2766C6.49413 10.3408 6.55062 10.3931 6.61607 10.4291C6.68152 10.4652 6.75404 10.4841 6.82762 10.4841C6.9012 10.4841 6.97372 10.4652 7.03917 10.4291C7.10461 10.3931 7.16111 10.3408 7.20396 10.2766L10.27 5.71406C10.3268 5.63125 10.2715 5.51562 10.1769 5.51562Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45395 1C3.85212 1 0.931641 4.13438 0.931641 8C0.931641 11.8656 3.85212 15 7.45395 15C11.0558 15 13.9763 11.8656 13.9763 8C13.9763 4.13438 11.0558 1 7.45395 1ZM7.45395 13.8125C4.46359 13.8125 2.0381 11.2094 2.0381 8C2.0381 4.79063 4.46359 2.1875 7.45395 2.1875C10.4443 2.1875 12.8698 4.79063 12.8698 8C12.8698 11.2094 10.4443 13.8125 7.45395 13.8125Z",
    fill: "#FF9900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8d1da3b1437e824a37cf6ff278f80e20.svg";
export { ForwardRef as ReactComponent };